import gql from 'graphql-tag'

export default gql`query {
  getMedias {
    id
		type
		name
		file
		size
		height
		width
  }
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/media/getMedias.js